import { Locale } from '../const';
// @ts-ignore (TS does not expect us to load JSON files)
import enGlobal from './en/global.json';
// @ts-ignore (TS does not expect us to load JSON files)
import enBlocks from './en/blocks.json';
// @ts-ignore (TS does not expect us to load JSON files)
import enValidation from './en/validation.json';
// @ts-ignore (TS does not expect us to load JSON files)
import deGlobal from './de/global.json';
// @ts-ignore (TS does not expect us to load JSON files)
import deBlocks from './de/blocks.json';
// @ts-ignore (TS does not expect us to load JSON files)
import deValidation from './de/validation.json';
// @ts-ignore (TS does not expect us to load JSON files)
import deCHGlobal from './de-CH/global.json';
// @ts-ignore (TS does not expect us to load JSON files)
import deCHBlocks from './de-CH/blocks.json';
// @ts-ignore (TS does not expect us to load JSON files)
import deCHValidation from './de-CH/validation.json';
// @ts-ignore (TS does not expect us to load JSON files)
import enUSGlobal from './en-US/global.json';
// @ts-ignore (TS does not expect us to load JSON files)
import enUSBlocks from './en-US/blocks.json';
// @ts-ignore (TS does not expect us to load JSON files)
import enUSValidation from './en-US/validation.json';
// @ts-ignore (TS does not expect us to load JSON files)
import frCHGlobal from './fr-CH/global.json';
// @ts-ignore (TS does not expect us to load JSON files)
import frCHBlocks from './fr-CH/blocks.json';
// @ts-ignore (TS does not expect us to load JSON files)
import frCHValidation from './fr-CH/validation.json';
// @ts-ignore (TS does not expect us to load JSON files)
import frGlobal from './fr/global.json';
// @ts-ignore (TS does not expect us to load JSON files)
import frBlocks from './fr/blocks.json';
// @ts-ignore (TS does not expect us to load JSON files)
import frValidation from './fr/validation.json';

export const languages = ['default', ...Object.values(Locale)] as const;
export const namespaces = ['global', 'blocks', 'validation'] as const;
export type Namespace = (typeof namespaces)[number];
export const defaultNS = 'global' as const;

export const resources: Record<Locale | 'default', Record<Namespace, any>> = {
  default: { blocks: undefined, global: undefined, validation: undefined },
  [Locale.En]: { blocks: enBlocks, global: enGlobal, validation: enValidation },
  [Locale.De]: { blocks: deBlocks, global: deGlobal, validation: deValidation },
  [Locale.DeCH]: { blocks: deCHBlocks, global: deCHGlobal, validation: deCHValidation },
  [Locale.EnUS]: { blocks: enUSBlocks, global: enUSGlobal, validation: enUSValidation },
  [Locale.FrCH]: { blocks: frCHBlocks, global: frCHGlobal, validation: frCHValidation },
  [Locale.Fr]: { blocks: frBlocks, global: frGlobal, validation: frValidation },
};
